snap-icon {
  align-items: center;
  display: inline-flex;
  justify-content: center;
  position: relative;

  span {
    box-sizing: border-box;
    display: inline-flex;
  }

  snap-indicator {
    position: absolute;
    z-index: 100;
  }

  &[state="default"] {
    &[size="md"] {
      snap-indicator {
        right: -5px;
        top: -1px;
      }
    }

    &[size="lg"] {
      snap-indicator {
        right: -2px;
        top: 0;
      }
    }

    &[size="xl"] {
      snap-indicator {
        right: 2px;
        top: 1px;
      }
    }
  }

  &[state="rounded"] {
    snap-indicator {
      right: -10px;
      top: -8px;
    }
  }

  &[state="square"] {
    snap-indicator {
      right: -12px;
      top: -12px;
    }

    &[size="xl"] {
      snap-indicator {
        right: -14px;
        top: -14px;
      }
    }
  }

  .snap-icon {
    position: relative;

    &.snap-icon--rounded {
      border-radius: 9999rem;
    }

    &.snap-icon--square {
      border-radius: 5px;
    }

    &.snap-icon--rounded,
    &.snap-icon--square {
      border-style: solid;

      &--xs {
        border-width: 8px;
        height: 32px;
        width: 32px;
      }

      &--sm {
        border-width: 8px;
        height: 36px;
        width: 36px;
      }

      &--md {
        border-width: 10px;
        height: 44px;
        width: 44px;
      }

      &--lg {
        border-width: 10px;
        height: 52px;
        width: 52px;
      }

      &--xl {
        border-width: 12px;
        height: 64px;
        width: 64px;
      }
    }

    svg {
      height: 100%;
      width: 100%;
    }
  }
}


